/* Site-wide US IP price gate. Detects a US visitor with the same
   /browsing_context_suggestions.json call snippets/gokwik.liquid and
   kbv4-pdp.js's initUsNotifyGate() already use, then marks <html> with
   .kb-us-ip so CSS on any page can hide price markup (homepage range grid,
   compare page, store grid, search results, etc.) without each of those
   systems duplicating the same fetch. Re-checked fresh on every page load,
   no caching - matches the existing PDP/gift-voucher gate's behaviour.
   Fails open on any error or non-US result: prices stay visible unless a
   US IP is positively detected. This only ever adds the class, never the
   PDP/gift-voucher opt-in gate, which is unrelated and untouched. */
(function () {
  fetch('/browsing_context_suggestions.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country_name;
      if (country !== 'United States') return;
      document.documentElement.classList.add('kb-us-ip');
    })
    .catch(function () {});
})();
